import { render, staticRenderFns } from "./NovoCliente.vue?vue&type=template&id=6f6fe0c4&"
import script from "./NovoCliente.vue?vue&type=script&lang=js&"
export * from "./NovoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports